<script>
	import { api_pullEntitySets, excludeSets } from "../stores.js";

	let cardCategories = ["news"];

	async function pullEntitySets() {
		console.log("Pulling entity sets...");
		const resp = await fetch($api_pullEntitySets, {
			method: "GET",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		});
		const response = await resp.json();
		let data;
		let obj = {};
		if (response.success === "true") {
			console.log("Pulled entity sets successfully");
			data = JSON.parse(response.data.entity_sets);
			
			// ignore test category
			data = data.filter((d) => d.entity_category !== "test");
			console.log(data);
			// exclude sets in $excludeSets
			data = data.filter((d) => !$excludeSets.includes(d.entity_set));

			// get categories
			cardCategories = data.map((i) => i.entity_category);
			// get unique categories
			cardCategories = cardCategories
				.filter((v, i, a) => a.indexOf(v) === i)
				.sort();
			obj["data"] = data;
			obj["cardCategories"] = cardCategories;

			// n entities per set
			let entity_set_n = {};
			obj.data.forEach((i) => {
				entity_set_n[i.entity_set] = i.num_entities;
			});
			obj.entity_set_n = entity_set_n;

			// get entity sets for each category
			obj["entity_sets"] = {};
			cardCategories.forEach((c) => {
				let entity_sets = data.filter((d) => d.entity_category === c);
				entity_sets = entity_sets.map((e) => e.entity_set);
				// add no. of cards in each set (setname [count])
				let entity_set_newnames = [];
				entity_sets.forEach((i) => {
					const n = entity_set_n[i];
					entity_set_newnames.push(i + " [" + n + "]");
				});
				obj["entity_sets"][c] = entity_set_newnames;
			});

			localStorage.setItem(
				"createStudyPulledEntitySets",
				JSON.stringify(obj)
			);

			console.log("entitySets", obj);
		} else {
			console.log("Failed to pull entity sets");
			localStorage.removeItem("createStudyPulledEntitySets");
		}
		return obj;
	}
	pullEntitySets();
</script>
